import React from 'react'
import useExternalNavigation from '@/app/hooks/useExternalNavigation'
import { Button, ButtonVariant, Text } from '@/components'
import { Link } from 'app-components'

export default function LabeledData({
  icon,
  title,
  subtitle,
  href,
  buttonProps,
}: {
  icon?: React.ReactNode
  title: string
  subtitle: string | undefined | null
  href?: string | null
  buttonProps?: {
    text: string
    variant: ButtonVariant
    onClick: () => void
  }
}) {
  const { externallyNavigate } = useExternalNavigation()

  return (
    <div className="flex justify-between gap-2">
      <div className="flex flex-row flex-[4] gap-2 w-full items-start">
        {icon && <div className="flex-shrink-0">{icon}</div>}
        <div className="flex flex-col gap-1 overflow-hidden">
          <Text variant="body2">{title}</Text>
          {href ? (
            <Link
              className="overflow-hidden truncate text-ellipsis"
              onClick={() => externallyNavigate(href ?? '')}
            >
              {subtitle}
            </Link>
          ) : (
            <Text
              variant="body1"
              className="overflow-hidden truncate text-ellipsis"
            >
              {subtitle ?? 'Unknown'}
            </Text>
          )}
        </div>
      </div>
      {buttonProps && (
        <div className="flex-[1]">
          <Button
            id="edit-account-number-btn"
            small={true}
            variant={buttonProps.variant}
            onClick={buttonProps.onClick}
          >
            {buttonProps.text}
          </Button>
        </div>
      )}
    </div>
  )
}
